import React, { useState, useEffect } from "react";
import { Application } from "@/api/applications";
import { Role, RolePrivileges } from "@/api/roles";
import { Privilege } from "@/api/privileges";
import RigthPanel from "@/ui-controls/RigthPanel";
import NewAppRolePrivilegeForm from "@/components/privileges/appRolePrivileges/NewAppRolePrivilegeForm";

interface Props {
  application: Application | undefined;
  role: Role | undefined;
  appPrivileges: Privilege[];
  unassignedAppPrivileges: Privilege[];
  isPanelOpenned: boolean;
  onSaveNewAppPrivilege?: (privilege: Privilege) => any;
  onAddRolePrivilege?: (rolePrivileges: RolePrivileges) => any;
  onPanelClosed?: () => any;
}

const NewAppRolePrivilegePanel = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  const handleError = (error: any) => {
    // Error handling would go here in real app
  };

  return (
    <>
      <RigthPanel
        header="Add Role Privilege"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewAppRolePrivilegeForm}
        childProps={{
          application: props.application,
          role: props.role,
          allAppPrivileges: props.appPrivileges,
          unassignedAppPrivileges: props.unassignedAppPrivileges,
          isSaving: isSaving,
          onClose: () => onClosePanel(),
          //onSavePrivilege: savePrivilege,
          onSave: (rolePrivileges: RolePrivileges) => {
            if (props.onAddRolePrivilege)
              props.onAddRolePrivilege(rolePrivileges);
            onClosePanel();
          },
        }}
      />
    </>
  );
};

export default NewAppRolePrivilegePanel;
